import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

import { makeStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";

import HorizontalAssetPreview from "../../AssetUploader/Shared/HorizontalAssetPreview";
import { reorderCreatives } from "../../../actions/app/creatives";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    // border: "1px solid rgba(0, 0, 0, 0.26)",
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-around"
  },
  aside: {
    width: "95%"
  },
  h6: {
    fontWeight: 400,
    fontSize: "1.15rem"
  }
}));

export default function HorizontalAssetList({
  isClickEnabled,
  isDragDisabled,
  handleSelectCard = () => {},
  isWeightEditable,
  isThumbnailEnabled,
  isWeightEnabled,
  selectedIds
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const creatives = useSelector((state) => state.creatives);
  const selectedList = selectedIds ? selectedIds : creatives.selectedIds;

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    dispatch(reorderCreatives(draggableId, source.index, destination.index));
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-1">
        {(provided) => (
          <Paper
            innerRef={provided.innerRef}
            {...provided.droppableProps}
            className={classes.paper}
          >
            <aside className={classes.aside}>
              {creatives.allIds.map((id, index) => {
                if (creatives.byId[id].creativeRole === "PRIMARY") {
                  return (
                    <HorizontalAssetPreview
                      id={id}
                      index={index}
                      key={id}
                      asset={creatives.byId[id]}
                      isClickEnabled={isClickEnabled}
                      isDragDisabled={isDragDisabled}
                      isCardSelected={selectedList.includes(id)}
                      handleSelectedCard={handleSelectCard}
                      isWeightEditable={isWeightEditable}
                      isThumbnailEnabled={isThumbnailEnabled}
                      isWeightEnabled={isWeightEnabled}
                    />
                  );
                }
                return null;
              })}
              {provided.placeholder}
            </aside>
          </Paper>
        )}
      </Droppable>
    </DragDropContext>
  );
}
